import React from "react";
import Page from "components/Page";
import { Props } from "./Programmes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Programmes = lazyWithRetry(() => import("./Programmes"));

export default (props: Props) => (
  <Page>
    <Programmes {...props} />
  </Page>
);
